<template>
    <div v-if="show" class="modal">
        <div class="modal-content max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <span class="close" @click="closeModal">&times;</span>
            <div id="map" style="width: 100%; height: 500px;"></div>
        </div>
    </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Icon from "@/Shared/Icon"

export default {
    components: {
        Head,
        Icon
    },
    layout: Layout,
    props: {
        selectedPoint: Object,
        types: Array,
        selectedLake: Object,
        show: Boolean,
        mapKey: String,
        multiplePoints: {
            type: Boolean,
            default: false
        },
        points: {
            type: Array,
            default: []
        },
        date: {
            type:String,
            default: ''
        }
    },
    mounted() {
        this.loadGoogleMapsScript().then(() => {
            if (this.multiplePoints) {
                this.initNewMapMultiple()
            } else {
                this.initNewMap()
            }
        });
    },
    methods: {
        closeModal() {
            this.$emit('update:show', false);
        },
        getFontAwesomeIconUrl() {
            const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="white" stroke="red"
                             stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map-pin">
                            <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>`
            return `data:image/svg+xml;base64,${btoa(svg)}`;
        },
        async loadGoogleMapsScript() {
            return new Promise((resolve, reject) => {
                if (window.google && window.google.maps) {
                    resolve();
                } else {
                    const script = document.createElement('script');
                    script.src = `https://maps.googleapis.com/maps/api/js?key=${this.mapKey}&callback`;
                    script.async = true;
                    script.defer = true;
                    script.setAttribute('loading', 'async');
                    document.head.appendChild(script);
                    script.onload = () => {
                        resolve();
                    };
                    script.onerror = (error) => {
                        reject(error);
                    };
                }
            });
        },
        initNewMap() {
            const map = new google.maps.Map(document.getElementById('map'), {
                center: {lat: parseFloat(this.selectedLake.latitude), lng: parseFloat(this.selectedLake.longitude)},
                zoom: 16,
                mapTypeId: google.maps.MapTypeId.SATELLITE
            });

            new google.maps.Marker({
                position: {lat: parseFloat(this.selectedPoint.latitude), lng: parseFloat(this.selectedPoint.longitude)},
                map: map,
                title: this.selectedPoint.name,
                icon: this.getFontAwesomeIconUrl()
            });
        },
        initNewMapMultiple() {
            const map = new google.maps.Map(document.getElementById('map'), {
                center: {lat: parseFloat(this.selectedLake.latitude), lng: parseFloat(this.selectedLake.longitude)},
                zoom: 16,
                mapTypeId: google.maps.MapTypeId.SATELLITE
            });
            this.points.forEach(point => {
                let marker = new google.maps.Marker({
                    position: {lat: parseFloat(point.latitude), lng: parseFloat(point.longitude)},
                    map: map,
                    title: point.name,
                    icon: this.getFontAwesomeIconUrl('map-marker-alt')
                });

                marker.addListener('click', () => {
                    this.$inertia.get(this.$route('index.point.view', {
                            lake: this.selectedLake.id,
                            point: point.id,
                            date: this.date
                        }))
                });
            })
        }
    },
}
</script>

<style scoped>
.modal {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}
</style>
